module.exports = __webpack_public_path__ + "img/betting_close.87d87344.png";